import { useRouter } from 'next/compat/router';
import { useStores } from 'contexts/stores';
import { PBB_NAME } from 'src/payments/constants';

type OpenDutchiePayType = {
  cname?: string; // TODO: This prop is no longer being used. Remove it and update any consumers passing it.
  step?: string;
  onCloseModal?: () => void;
  refHref?: string;
  enrollmentSource?: string;
};

export const useOpenDutchiePay = ({
  step = '',
  onCloseModal,
  refHref,
  enrollmentSource = '',
}: OpenDutchiePayType): { openDutchiePay: (overrideStep?: string) => void } => {
  const router = useRouter();
  const { UI, Cart } = useStores();
  const cname = Cart?.dispensary?.cName;

  const openDutchiePay = (overrideStep?: string): void => {
    const computedStep = overrideStep ?? step;
    const queryOptions = {
      ...(['default', 'mobile-ecomm', 'plus', 'embedded', 'store-front'].includes(UI.variant) && {
        refUrl: refHref ?? router?.asPath,
        ...(cname && { cname }),
        ...(computedStep && { step: computedStep }),
        ...(enrollmentSource && { enrollmentSource }),
      }),
    };

    if (UI.isMobileEcommApp) {
      // eslint-disable-next-line no-alert
      alert(`Log in to your account on dutchie.com to sign up for ${PBB_NAME}.`);
    } else {
      void router?.push({
        pathname: `/pay/signup`,
        query: queryOptions,
      });
      if (onCloseModal) {
        onCloseModal();
      }
    }
  };
  return {
    openDutchiePay,
  };
};
